import { object, string, number, array } from 'yup'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { safify } from 'components/Wizards/schemas/utils/safify'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { language } from 'components/Wizards/schemas/shared/language'
import { includeEmojis } from 'components/Wizards/schemas/shared/includeEmojis'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { meta } from '../schemaCommon'
import { filename } from 'components/Wizards/schemas/shared/filename'
import { project } from 'components/Wizards/schemas/shared/project'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'

export const FlowP2Schema = ({ generationType }: { generationType: string }) => {
  const BrainstormDetailsSchema = object({
    content_type: string()
      .oneOf([
        'Informational',
        'Educational',
        'Descriptive',
        'Instructional',
        'Promotional',
        'Supportive',
        'Transparency',
        'Narrative',
        'Technical',
        'Policy',
        'Reference',
      ])
      .default('Informational')
      .meta({
        label: '',
        placeholder: 'What approach do you want for this content?',
        oneOfPills: true,
      })
      .transform(safify),
    brand_kit_id: brandKitId
      .meta({
        label: 'Pick a Brand Kit',
      })
      .optional(),
    tone: tone.meta({
      autoFill: false,
    }),
  }).meta({
    title: 'What style of content do you need?',
    submitLabel: 'Continue',
  }) as StepSchema

  const RefinementSchema = object({
    topic: topic.meta({
      type: 'textarea',
      autoFill: true,
      generate: false,
      generationType,
    }),
    ideas_count: number().default(10).oneOf([3, 5, 7, 10]).meta({
      label: 'How many section variations?',
    }),
  }).meta({
    submitLabel: 'Continue',
  }) as StepSchema

  const KeywordsSchema = object({
    seo_words: array().of(string()).min(1, 'Please add at least one keyword').default([]).meta({
      label: 'SEO Keywords',
      autoFill: true,
      placeholder: 'Add keywords for SEO (press enter or tab to separate)',
    }),
    filename,
    project,
    language: language.meta({ overflow: true }),
    include_emojis: includeEmojis.meta({ overflow: true }),
  }).meta({
    title: 'Add final details',
    submitLabel: 'Generate Content',
  }) as StepSchema

  return {
    meta,
    steps: [BrainstormDetailsSchema, RefinementSchema, KeywordsSchema],
  } as MultiStepSchema<GenerationType>
}
